import React, { useContext } from 'react';
import classNames from 'classnames';
import { eventsDuck } from '@eb/redux-destination';

import { Organizer } from '../types';
import { EventContext, UserContext } from '../context';

import { SocialWidget } from './SocialWidget';
import { OrganizerEvents } from './OrganizerEvents';
import { FollowOrganizer } from './FollowOrganizer';
import { ContactOrganizerButton } from './ContactOrganizerButton';

import './Main.scss';

interface MainProps {
    organizer: Organizer;
}

export const Main: React.SFC<MainProps> = (props) => {
    const { isAuthenticated } = useContext(UserContext);
    const { dispatch } = useContext(EventContext);
    const shouldRenderSocialContent =
        props.organizer.twitter || props.organizer.facebook;
    const eventSectionClasses = classNames('eds-g-cell', {
        'eds-g-cell-12-12 eds-g-cell-mn-8-12 eds-l-pad-right-4 eds-l-pad-bot-4': shouldRenderSocialContent,
        'eds-g-cell-12-12 eds-g-cell-mn-8-12 eds-g-offset-mn-2-12': !shouldRenderSocialContent,
    });

    const handleSaveEvent = async (id: string) => {
        if (id) {
            await eventsDuck.api.saveEvent(id);
            dispatch &&
                dispatch({ type: 'save', payload: { id, value: true } });
        }
    };

    return (
        <main className="main">
            <div className="follow-organizer-container">
                <FollowOrganizer organizer={props.organizer} />
            </div>
            <section
                className={eventSectionClasses}
                style={{ position: 'relative' }}
            >
                <OrganizerEvents
                    isAuthenticated={isAuthenticated}
                    onSaveEvent={handleSaveEvent}
                />
                <div className="contact-organizer-wrapper">
                    <ContactOrganizerButton />
                </div>
            </section>
            {shouldRenderSocialContent && (
                <section className="eds-g-cell eds-g-cell-12-12 eds-g-cell-mn-4-12">
                    <SocialWidget
                        facebook={props.organizer.facebook}
                        twitter={props.organizer.twitter}
                    />
                </section>
            )}
        </main>
    );
};
